/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deviceIntegrationsListSchedules } from "../funcs/deviceIntegrationsListSchedules.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDeviceIntegrationSchedulesResult } from "../models/components/listdeviceintegrationschedulesresult.js";
import {
  ListDeviceIntegrationSchedulesRequest,
  ListDeviceIntegrationSchedulesSecurity,
} from "../models/operations/listdeviceintegrationschedules.js";
import { unwrapAsync } from "../types/fp.js";
export type DeviceIntegrationSchedulesQueryData =
  ListDeviceIntegrationSchedulesResult;

export function prefetchDeviceIntegrationSchedules(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListDeviceIntegrationSchedulesRequest,
  security?: ListDeviceIntegrationSchedulesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDeviceIntegrationSchedulesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDeviceIntegrationSchedulesQuery(
  client$: GramCore,
  request: ListDeviceIntegrationSchedulesRequest,
  security?: ListDeviceIntegrationSchedulesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DeviceIntegrationSchedulesQueryData>;
} {
  return {
    queryKey: queryKeyDeviceIntegrationSchedules({
      provider: request.provider,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
    }),
    queryFn: async function deviceIntegrationSchedulesQueryFn(
      ctx,
    ): Promise<DeviceIntegrationSchedulesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deviceIntegrationsListSchedules(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDeviceIntegrationSchedules(
  parameters: {
    provider: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deviceIntegrations", "listSchedules", parameters];
}
